// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.intervention.PredictiveInterventionResponse */
/* istanbul ignore next */
@GandalfModel
export class PredictiveInterventionResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Date })
	createdOn!: Date;

	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfProperty({ designType: String })
	name!: string;

	@GandalfProperty({ designType: Number })
	predictiveInterventionId!: number;

	@GandalfProperty({ designType: String })
	results!: string | null;

}
